import React from 'react';
import { Package } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

const CatalogSelectionDialog = ({ open, onOpenChange, items, search, onSearchChange, onSelect, formatCurrency }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-2xl max-h-[80vh] overflow-hidden flex flex-col">
      <DialogHeader>
        <DialogTitle>Sélectionner depuis le catalogue</DialogTitle>
      </DialogHeader>
      <div className="mb-4">
        <Input
          placeholder="Rechercher par marque, modèle..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          data-testid="catalog-search-input"
        />
      </div>
      <div className="flex-1 overflow-y-auto min-h-0">
        {items.length === 0 ? (
          <div className="text-center py-8 text-slate-500">
            <Package className="w-12 h-12 mx-auto text-slate-300 mb-2" />
            <p>Aucun article dans le catalogue</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {items.map(item => (
              <button
                key={item.id}
                type="button"
                onClick={() => onSelect(item)}
                className="flex items-center gap-3 p-3 border rounded-lg hover:bg-blue-50 hover:border-blue-300 transition-colors text-left"
                data-testid={`catalog-select-${item.id}`}
              >
                <div className="w-12 h-12 rounded bg-slate-100 flex-shrink-0 overflow-hidden">
                  {item.image_url ? (
                    <img src={item.image_url} alt="" className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <Package className="w-6 h-6 text-slate-300" />
                    </div>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-slate-900 truncate">{item.marque}</p>
                  <p className="text-sm text-slate-600 truncate">{item.modele}</p>
                  {item.cout_unitaire && (
                    <p className="text-sm font-semibold text-blue-600">{formatCurrency(item.cout_unitaire)}</p>
                  )}
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </DialogContent>
  </Dialog>
);

export default CatalogSelectionDialog;
